import { render } from "./TourSlotBookSelector.vue?vue&type=template&id=2c08adfb&ts=true"
import script from "./TourSlotBookSelector.vue?vue&type=script&lang=ts"
export * from "./TourSlotBookSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__